import React from "react";
import LandingLayout from "components/common/landingLayout";
import FutureCare from "components/futurecare";

const FutureCarePage = () => {
  return (
    <LandingLayout>
      <FutureCare />
    </LandingLayout>
  );
};

export default FutureCarePage;
